export enum CargoCargoTaxiContractListingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type CargoCargoTaxiContractListingCargoCompany = {
  companyName: string;
};

export type CargoCargoTaxiContractListingTaxiCorporation = {
  companyName: string;
};

export type CargoCargoTaxiContractListingItem = {
  id: string;
  taxiCorporation: CargoCargoTaxiContractListingTaxiCorporation;
  cargoCompany: CargoCargoTaxiContractListingCargoCompany;
  publishingAllowed: boolean;
  model: CargoCargoTaxiContractListingModel;
  validSince: Date;
  validTo: Date;
  isValid: boolean;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
};

type CargoCargoTaxiContractListing = {
  data: CargoCargoTaxiContractListingItem[];
  totalCount: number;
};

export default CargoCargoTaxiContractListing;
